import { Config } from "../../../utils/config";
export const numberWithCommas = (number) => {
  var _a;
  return (_a = number == null ? void 0 : number.toString()) == null ? void 0 : _a.replace(Config.regExp.numberWithCommasRegex, ",");
};
